module.exports = __webpack_public_path__ + "img/voltaje_c.21e4be18.svg";